module.exports = __webpack_public_path__ + "img/1.621e8f56.jpg";